
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/start",
      function () {
        return require("private-next-pages/start.js");
      }
    ]);
  